































import { UseModal } from "@/components/root/modal";
import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import SelectOverviewModalVue from "./overview-selection-modal/SelectOverviewModal.vue";
import MS365Activities from "./sources/ms-365-activities/MS365Activities.vue";
import AwsS3 from "./sources/aws-s3/AwsS3.vue";
import Confluence from "./sources/confluence/Confluence.vue";
import AzStorage from "./sources/az-storage/AzStorage.vue";
import AzFileShare from "./sources/az-file-share/AzFileShare.vue";
import MsDynamics from "./sources/dynamics/MsDynamics.vue";
import MS365AtRest from "./sources/ms-365-at-rest/MS365AtRest.vue";
import Dropbox from "./sources/dropbox/Dropbox.vue";
import SourceNotConnectedVue from "./SourceNotConnected.vue";
import MS365Permissions from "./sources/ms-365-permissions/MS365Permissions.vue";
import MsSql from "./sources/ms-sql/MsSql.vue";
import Snowflake from "./sources/snowflake/SnowFlake.vue";
import OnPremise from "./sources/on-premise/OnPremise.vue";
import GenAiGovernance from "./sources/ms-365-gen-ai/GenAiGovernance.vue";
import { GEN_AI_SOURCE_ID } from "./sources/ms-365-gen-ai/data/model";
import { DataSourceType } from "../customize/data-sources/data/model";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
export default Vue.extend({
  setup() {
    const { current_overview, loading } = state;

    const show_overview_modal = () => {
      UseModal().show(SelectOverviewModalVue);
    };

    const current_source_cmp = computed(() => {
      if (!current_overview.value.enabled) {
        return SourceNotConnectedVue;
      }

      if (current_overview.value.id === GEN_AI_SOURCE_ID) {
        return GenAiGovernance;
      }

      switch (current_overview.value.id as DataSourceType) {
        case "dropbox_storage":
          return Dropbox;
        case "az_file_share":
          return AzFileShare;
        case "confluence":
          return Confluence;
        case "amazon_s3":
          return AwsS3;
        case "mssql_db":
          return MsSql;
        case "snowflake":
          return Snowflake;
        case "az_storage":
          return AzStorage;
        case "msft_dynamics":
          return MsDynamics;
        case "msft_365":
          return MS365AtRest;
        case "onprem_fs":
          return OnPremise;
        case "sp_site_permission":
          return MS365Permissions;
        case "motion_365":
        case "google_workspace":
        default:
          return MS365Activities;
        //case "in_motion_365_and_g_suite":
      }
    });

    /** dashboards that grow with their content and scroll with the page */
    const page_scroll = computed(
      () =>
        current_source_cmp.value === GenAiGovernance ||
        current_source_cmp.value === MS365Activities
    );

    const subs = {
      overview_menu: emptyFn(),
    };

    onMounted(() => {
      state.init();
      subs.overview_menu = EventBus.listen("show_overview_menu", () => {
        show_overview_modal();
      });
    });
    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));
    return {
      loading,
      current_overview,
      show_overview_modal,
      current_source_cmp,
      page_scroll,
    };
  },
});
